export enum SidebarType { SELECT_DRONE, ENTER_ROUTE_FORM };